<!-- Item Start Outlet -->
<ng-template [cxOutlet]="CartOutlets.LIST_ITEM">
  <td role="cell">
    <ng-template
      [cxOutlet]="CartOutlets.ITEM_CONFIGURATOR_ISSUES"
    ></ng-template>
    <ng-container *cxFeatureLevel="'4.2'">
      <cx-cart-item-validation-warning
        [code]="$any(item).product?.code"
      ></cx-cart-item-validation-warning>
    </ng-container>
    <div class="cx-table-item-container">
      <!-- Item Image -->
      <a
        [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
        tabindex="0"
        >
        <cx-media
          [container]="item.product?.images?.['PRIMARY']"
          format="cartIcon"
        ></cx-media>
      </a>
      <div class="cx-info">
        @if (item.product?.name) {
          <div class="cx-name">
            <a
              class="cx-link"
              [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
              >{{ item.product?.name }}</a
              >
            </div>
          }
          @if (item.product?.code) {
            <div class="cx-code">
              {{ 'cartItems.id' | cxTranslate }} {{ item.product?.code }}
            </div>
          }
          <!-- Item Price -->
          @if (item.basePrice) {
            <div class="cx-price">
              @if (item.basePrice) {
                <div class="cx-value">
                  {{ item.basePrice.formattedValue }}
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="cx-cart-addons">
        <!-- Item Details Outlet -->
        <ng-template [cxOutlet]="CartOutlets.ITEM_DETAILS"> </ng-template>

        <!-- Item Bundle Details Outlet -->
        <ng-template [cxOutlet]="CartOutlets.ITEM_BUNDLE_DETAILS"> </ng-template>

        <!-- Promotion -->
        <cx-promotions [promotions]="$any(item.promotions)"></cx-promotions>
      </div>

      <!-- Variants -->
      @if (item.product?.baseOptions?.length) {
        @for (
          variant of $any(item).product?.baseOptions[0]?.selected
          ?.variantOptionQualifiers
          ; track
          variant) {
          <div
            class="cx-property"
            >
            <!-- cx-mobile-header -->
            @if (variant.name && variant.value) {
              <div class="cx-label">
                {{ variant.name }}: {{ variant.value }}
              </div>
            }
          </div>
        }
      }
    </td>
    <!-- Mobile Item Price -->
    @if (item.basePrice) {
      <td role="cell" class="cx-price cx-mobile-only">
        <div class="cx-mobile-header">
          {{ 'cartItems.itemPrice' | cxTranslate }}
        </div>
        @if (item.basePrice) {
          <div class="cx-value">
            {{ item.basePrice.formattedValue }}
          </div>
        }
      </td>
    }
    <!-- Item Quantity -->
    <td role="cell" class="cx-quantity">
      <div
        class="cx-mobile-header"
        placement="left"
        title="{{ 'cartItems.quantityTitle' | cxTranslate }}"
        >
        {{ 'cartItems.quantity' | cxTranslate }}
      </div>
      <div class="cx-value" [class.readonly-value]="readonly">
        <!-- <app-item-counter
        [control]="quantityControl"
        [readonly]="$any(item).updateable || readonly || options.isSaveForLater"
        [max]="$any(item).product?.stock?.stockLevel"
        [allowZero]="true"
        >
      </app-item-counter> -->
      <app-item-counter [control]="quantityControl"
        >
      </app-item-counter>
    </div>
  </td>
  <!-- Total -->
  @if (options.isSaveForLater) {
    <td role="cell" class="cx-total">
      <div class="cx-mobile-header">
        {{ 'saveForLaterItems.stock' | cxTranslate }}
      </div>
      @if ($any(item).product?.stock?.stockLevel >= 0) {
        <div
          class="cx-value"
          >
          {{ item.product?.stock?.stockLevel }}
        </div>
      } @else {
        <div class="cx-value">
          {{ 'saveForLaterItems.forceInStock' | cxTranslate }}
        </div>
      }
    </td>
  } @else {
    @if (item.totalPrice) {
      <td role="cell" class="cx-total">
        <div class="cx-mobile-header">
          {{ 'cartItems.total' | cxTranslate }}
        </div>
        <div class="cx-value">{{ item.totalPrice.formattedValue }}</div>
      </td>
    }
  }

  @if (
    (!readonly || options.isSaveForLater || options.displayAddToCart) &&
    item.updateable
    ) {
    <td
      role="cell"
      class="cx-actions"
      >
      @if (!isProductOutOfStock(item.product)) {
        <ng-container
        *ngTemplateOutlet="
          options.optionalBtn;
          context: {
            $implicit: {
              loading: quantityControl.disabled,
              item: this.item,
              options: this.options
            }
          }
        "
    ></ng-container>
  }
  <!-- Availability -->
  @if (isProductOutOfStock(item.product)) {
    <span
      role="cell"
      class="cx-availability"
      >
      {{ 'addToCart.outOfStock' | cxTranslate }}
    </span>
  }
  @if (!readonly) {
    <button
      (click)="removeItem()"
      [cxAtMessage]="'cartItems.itemRemoved' | cxTranslate"
      [disabled]="quantityControl.disabled"
      attr.aria-label="{{ 'addToCart.removeFromCart' | cxTranslate }}"
      class="link cx-action-link cx-remove-btn"
      >
      {{ 'common.remove' | cxTranslate }}
    </button>
  }
</td>
}
</ng-template>
